import { render } from "./ModalPending2.vue?vue&type=template&id=07c6071a"
import script from "./ModalPending2.vue?vue&type=script&lang=js"
export * from "./ModalPending2.vue?vue&type=script&lang=js"

import "./ModalPending2.vue?vue&type=style&index=0&id=07c6071a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__